import { Component, type ReactNode, type ErrorInfo } from 'react';

interface Props {
  children: ReactNode;
  fallbackMessage?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', minHeight: '60vh', padding: '2rem',
        color: '#64748b', fontFamily: '"DM Sans", sans-serif',
      }}>
        <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>Something went wrong</div>
        <p style={{ color: '#94a3b8', maxWidth: 480, textAlign: 'center', marginBottom: '1.5rem' }}>
          {this.props.fallbackMessage ?? 'An unexpected error occurred. Try refreshing or click below.'}
        </p>
        <pre style={{
          background: '#f1f5f9', padding: '1rem', borderRadius: 8,
          fontSize: '0.8rem', maxWidth: 600, overflow: 'auto', marginBottom: '1.5rem',
        }}>
          {this.state.error?.message}
        </pre>
        <button
          onClick={() => this.setState({ hasError: false, error: null })}
          style={{
            padding: '0.6rem 1.5rem', borderRadius: 8, border: 'none',
            background: '#3b82f6', color: '#fff', cursor: 'pointer',
            fontSize: '0.95rem', fontWeight: 600,
          }}
        >
          Try Again
        </button>
      </div>
    );
  }
}
